module.exports = __webpack_public_path__ + "3fe82297361a0e6f4cfb111049873426.svg";